module.exports = __webpack_public_path__ + "img/SpadefootQuiz_D.4ce97578.png";